let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kCsFm")).then(() => parcelRequire('j7B0X'));